import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { IFilterState, ProductPriceType } from 'src/areas/product/types';
import { IPricelistFilterConfig } from '../../types';
import { FilterEnum } from '../types';
import { initialFilterState } from 'src/areas/product/constants';

export const getActiveNonDefaultFilters = (
  t: TranslateFunc,
  filters: IFilterState,
  hiddenListOptions: string[]
) => {
  return filterNonDefaultFilters(getAllFilters(t, filters, hiddenListOptions));
};

export const getActiveFilters = (
  t: TranslateFunc,
  filters: IFilterState,
  hiddenListOptions: string[]
) => {
  return getAllFilters(t, filters, hiddenListOptions).filter(
    f => f.checked === true
  );
};

export const filterNonDefaultFilters = (
  filters: IPricelistFilterConfig[]
): IPricelistFilterConfig[] => {
  return filters.filter(filter => filter.checked !== filter.defaultChecked);
};

export const getAllFilters = (
  t: TranslateFunc,
  filters: IFilterState,
  hiddenListOptions: string[]
): IPricelistFilterConfig[] => {
  return [
    {
      name: FilterEnum.PRICES_INC_SHIPPING,
      quickFilter: true,
      checked: filters.showPricesInclShipping,
      defaultChecked: initialFilterState.showPricesInclShipping,
      label: t('common', 'sort.price_includes_shipping'),
      hide: false,
    },
    {
      name: FilterEnum.PICKUP_ONLY,
      quickFilter: false,
      checked: filters.showPickupOnly,
      defaultChecked: initialFilterState.showPickupOnly,
      label: t('product', 'price-filter.pickup-only'),
      caption: t('product', 'price-filter.pickup-only-caption'),
      hide: Boolean(
        hiddenListOptions.filter(
          option => option === ProductPriceType.PICKUP_ONLY
        ).length
      ),
    },
    {
      name: FilterEnum.INTERNATIONAL,
      quickFilter: false,
      checked: filters.showInternational,
      defaultChecked: initialFilterState.showInternational,
      label: t('product', 'price-filter.international'),
      caption: t('product', 'price-filter.international-caption'),
      hide: Boolean(
        hiddenListOptions.filter(
          option => option === ProductPriceType.INTERNATIONAL
        ).length
      ),
    },
    {
      name: FilterEnum.UNAVAILABLE,
      quickFilter: false,
      checked: filters.showUnavailable,
      defaultChecked: initialFilterState.showUnavailable,
      label: t('product', 'price-filter.not-available-for-purchase'),
      caption: t('product', 'price-filter.not-available-for-purchase-caption'),
      hide: false,
    },
  ];
};
